import { useState } from "react";
import google from "../../assets/images/buttons/googleFooter.svg";
import googleOnHover from "../../assets/images/buttons/googleFooterOnHover.svg";
import apple from "../../assets/images/buttons/appleFooter.svg";
import appleOnHover from "../../assets/images/buttons/appleFooterOnHover.svg";
import Validation from "../../constants/validation";

const useFooter = () => {
  const width = typeof window !== "undefined" ? window.innerWidth : null;

  const [buttonGoogle, setButtonGoogle] = useState(google);
  const [buttonApple, setButtonApple] = useState(apple);
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [message, setMessage] = useState("");
  const [messageError, setMessageError] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const {
    nameValidation,
    emailValidation,
    phoneValidation,
    messageValidation,
  } = Validation();

  const nameValidate = nameValidation(name);
  const emailValidate = emailValidation(email);
  const phoneValidate = phoneValidation(phone);
  const messageValidate = messageValidation(message);

  const googleHovered = () => {
    setButtonGoogle(googleOnHover);
  };

  const googleUnhovered = () => {
    setButtonGoogle(google);
  };

  const appleHovered = () => {
    setButtonApple(appleOnHover);
  };

  const appleUnhovered = () => {
    setButtonApple(apple);
  };

  const scroll = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const changeName = (e) => {
    setName(e.target.value);
  };

  const changeEmail = (e) => {
    setEmail(e.target.value);
  };

  const changePhone = (e) => {
    setPhone(e.target.value);
  };

  const changeMessage = (e) => {
    setMessage(e.target.value);
  };

  const check = () => {
    !!nameValidate ? setNameError(true) : setNameError(false);
    !!emailValidate ? setEmailError(true) : setEmailError(false);
    !!phoneValidate ? setPhoneError(true) : setPhoneError(false);
    !!messageValidate ? setMessageError(true) : setMessageError(false);
  };

  const textToSend = `<b>имя</b>: ${name},%0A<b>емейл</b>: ${email},%0A<b>телефон</b>: ${phone},%0A<b>сообщение</b>: ${message}`;

  const send = () => {
    check();
    if (
      !nameError &&
      name &&
      !emailError &&
      email &&
      !phoneError &&
      !messageError &&
      message
    ) {
      fetch(
        `https://api.telegram.org/bot${process.env.CHAT_BOT_TOKEN}/sendMessage?chat_id=${process.env.CHAT_ID}&parse_mode=html&text=${textToSend}`
      )
        .then((res) => res.json())
        .then((result) => console.log(result));
      setShowModal(true);
      setTimeout(() => setShowModal(false), 2000);
      setName("");
      setEmail("");
      setPhone("");
      setMessage("");
    }
  };

  return {
    buttonGoogle,
    buttonApple,
    googleHovered,
    googleUnhovered,
    appleHovered,
    appleUnhovered,
    width,
    scroll,
    name,
    changeName,
    nameError,
    send,
    email,
    changeEmail,
    emailError,
    phone,
    changePhone,
    phoneError,
    message,
    changeMessage,
    messageError,
    showModal,
  };
};

export default useFooter;
